import { createModule } from '~/factories/store'
import actions from '~/store/modules/shared/trades/actions'
import mutations from '~/store/modules/shared/trades/mutations'
import state from '~/store/modules/shared/trades/state'

export default createModule({
  actions,
  mutations,
  state
})
